import _ from "lodash";
import { getUrlParameter } from "../../app/core/util/util";
import { ll } from "./ll";

export const emptyFn = function () { };

export const empty$Object = $("");

export function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}

export function setTitle(title: string) {
    document.title = ll(title);
}

export function setHistory(entity: string, replace: boolean, stateObject: any, screen?: string, params?: string, hash?: string) {
    screen = screen == null ? null : screen;
    params = params == null ? null : params;
    var urlString = `/${entity}/`;
    if (screen != null && params != null && hash == null) {
        urlString = `/${entity}/?screen=${screen}&${params}`;
    } else if (screen != null && params == null && hash == null) {
        urlString = `/${entity}/?screen=${screen}`;
    } else if (screen == null && params != null) {
        urlString = `/${entity}/?${params}`;
    } else if (screen == null && params == null && hash != null) {
        urlString = `/${entity}/#${hash}`;
    } else if (screen == null && params != null && hash != null) {
        urlString = `/${entity}/?${params}#${hash}`;
    }

    replace ? window.history.replaceState(stateObject, document.title, urlString)
                : window.history.pushState(stateObject, document.title, urlString);
}

export function getHistoryState(property: string): any {
    var urlParam = property == "hash" ? location.hash : getUrlParameter(property);
    if (urlParam != ""){
        return urlParam;
    } else if (_.has(window, `history.state.${property}`) && window.history.state[property] != null) {
        return window.history.state[property];
    }
    return null;
}

export function getStateObject(): {} {
    return {
        hash: location.hash == "" ? null : location.hash,
        customerNumber: getHistoryState("customerNumber"),
        orderTemplateNumber: getHistoryState("orderTemplateNumber"),
        siteNumber: getHistoryState("siteNumber"),
        shipToNumber: getHistoryState("shipToNumber"),
        equipmentId: getHistoryState("equipmentId"),
        callNumber: getHistoryState("callNumber"),
        orderNumber: getHistoryState("orderNumber"),
        orderId: getHistoryState("orderId"),
        contractNumber: getHistoryState("contractNumber"),
        quoteNumber: getHistoryState("quoteNumber"),
        code: getHistoryState("code"),
        screen: getHistoryState("screen")
    };
}

export function watchForDuplicateElementIds() {
    // setInterval(function () {
    //     var foundDuplicate = false;
    //     $.each($("[id]"), function (indx) {
    //         if (this.id) {
    //             var ids = $('[id="' + this.id + '"]');
    //             if (ids.length > 1 && ids[0] == this) {
    //                 console.warn("1 Ids #" + this.id);
    //                 console.dir && console.dir($("#" + this.id));
    //                 foundDuplicate = true;
    //             }
    //         }
    //     });
    //     if (foundDuplicate) {
    //         alert({
    //             header: "Warning",
    //             type: "warning",
    //             message: "Multiple Ids detected, check console warnings",
    //             wait: 5000
    //         });
    //     }
    // }, 15000);
}

/**
 * Set value in localStorage. Will JSON.stringify the value.
 *
 * Use z.setLocalStorage if you want to compress with LZString
 */
export function setLocalStorage(key, value) {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        if (console) {
            console.warn("Failed saving the '{" + key + ": " + value + "}' pair, because the localStorage is full.");
        }
    }
}

export function flatten(ob) {
    var toReturn = {};

    for (var i in ob) {
        if (!ob.hasOwnProperty(i)) {
            continue;
        }

        if ((typeof ob[i]) == "object") {
            var flatObject = flatten(ob[i]);
            for (var x in flatObject) {
                if (!flatObject.hasOwnProperty(x)) {
                    continue;
                }

                toReturn[x] = flatObject[x];
            }
        } else {
            toReturn[i] = ob[i];
        }
    }
    return toReturn;
}

export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

/**
 * Get value from localStorage by key. Will JSON.parse the value.
 *
 * Use z.getLocalStorage if you want to decompress with LZString
 */
export function getLocalStorage(key) {
    var value;
    try {
        value = JSON.parse(localStorage.getItem(key));
    } catch (e) {
        value = null;
    }

    if (value === null) {
        console.warn("Could not find " + key + " in localStorage");
        return null;
    }

    return value;
}

/**
 * Set value in sessionStorage. Will JSON.stringify the value.
 *
 * Use z.setSessionStorage if you want to compress with LZString
 */
export function setSessionStorage(key, value) {
    try {
        sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        if (console) {
            console.warn("Failed saving the '{" + key + ": " + value + "}' pair, because the sessionStorage is full.");
        }
    }
}

/**
 * Get value from sessionStorage by key. Will JSON.parse the value.
 *
 * Use z.getSessionStorage if you want to decompress with LZString
 */
export function getSessionStorage(key) {
    var value;
    try {
        value = JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
        value = null;
    }

    if (value === null) {
        console.warn(`Could not find ${key} in sessionStorage`);
        return null;
    }

    return value;
}

export function enforceCapitalization(input) {
    return _.startCase(_.toLower(input));
}

export enum caseSensitivityOptions {
    "Anything" = "A",
    "Uppercase" = "U",
    "Lowercase" = "L"
}

export function enforceCaseSensitivity(
    input: string,
    sensitivity: caseSensitivityOptions | number
) {
    if (!(sensitivity in caseSensitivityOptions)) {
        try {
            sensitivity = window.z.codes.CaseSensitivity.find(
                cs => cs.Id === sensitivity
            ).CodeNumber;
        } catch {
            return input;
        }
    }
    switch (sensitivity) {
        case caseSensitivityOptions.Lowercase:
            return input.toLowerCase();
        case caseSensitivityOptions.Uppercase:
            return input.toUpperCase();
        default:
            return input;
    }
}

export function showPortalContainer(shouldShow: boolean = true) {
    let widgetContainer = $("#PortalContainer"),
        hasLookerDashboards = widgetContainer.hasClass("looker-dashboard-wrapper");

    if (hasLookerDashboards && shouldShow) {
        $("body").addClass("looker");
    } else {
        $("body").removeClass("looker");
    }

    if (shouldShow) {
        widgetContainer.show();
    } else {
        widgetContainer.hide();
    }
}

export function hidePortalContainer() {
    showPortalContainer(false);
}

// Strips HTML out of a string.
// Args
// html: A string of html to be modified.
// keepStyling: Does not remove tags that just style text. Default is false.
// insertLineBreaks: Adds a line break at the end of text stripped from li tags.
//                   If false, then spaces will be inserted. Default is false.
export function stripHTML(args: any) {
    // Insert breaks into places that'll become new lines or spaces
    args.html = args.html.replaceAll(new RegExp("<div><br[ ]*/></div>"), "<br/>");
    args.html = args.html.replaceAll("<div>", "<br/><div>");
    args.html = args.html.replaceAll("</li><li>", "</li><br/><li>");
    args.html = args.html.replaceAll("<ul>", "<br/><ul>");
    args.html = args.html.replaceAll("</p><p>", "</p><br/><p>");

    if (args.html.startsWith("<br/>")) {
        args.html = args.html.substring(5);
    }

    var result = stripRecursive(args);
    return result;
}

// Helper function for stripHTML.
function stripRecursive(args: any) {
    var result = "";
    args.keepStyling = args.keepStyling === undefined ? false : args.keepStyling;
    args.insertLineBreaks = args.insertLineBreaks === undefined ? false : args.insertLineBreaks;

    if (!args.html) {
        return "";
    }

    args.html = args.html.replaceAll(new RegExp("<br[ ]*/>"), args.insertLineBreaks ? "\n" : "&nbsp");

    var elements = $.parseHTML(args.html);

    elements.forEach(element => {
        if (element.nodeName == "#text") {
            result += `${element.textContent}`;
        } else {
            var content = "";
            args.html = element.innerHTML;

            switch (element.nodeName) {
                case "STRONG":
                    if (args.keepStyling) {
                        content = `<strong>${stripRecursive(args)}</strong>`;
                    } else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                case "EM":
                    if (args.keepStyling) {
                        content = `<em>${stripRecursive(args)}</em>`;
                    } else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                case "SPAN":
                    if (args.keepStyling) {
                        content = `<span style="${element.style.cssText}">${stripRecursive(args)}</span>`;
                    } else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                default:
                    content = `${stripRecursive(args)}`;
            }

            result += content;
        }
    });

    return result;
}
export const metersToMiles = m => m * 0.000621371;
export const metersToKilometers = m => m / 1000;